import React from 'react'
import styled from 'styled-components'
import bg from '../../assets/static/bg_products.jpg'
import maceta from '../../assets/static/maceta_products.jpg'
import Button from '../../components/Button'
import Title from '../../components/Title'
import { useTranslation } from "react-i18next"
  
const Products = () => {
  const { t } = useTranslation()
  return (
    <Main>
      <Img src={bg} alt="bg" />
      <Item>
        <Title size={'mid'} color="white">
          {t('home.bannerOne.title')}
        </Title>
        <P>
          {t('home.bannerOne.desc')}
        </P>
        <div>
          <Button>{t('home.bannerOne.cta')}</Button>
        </div>
      </Item>
      <Item>
        <Title size={'mid'} color="white">
            {t('home.bannerTwo.title')}
        </Title>
        <P>
          {t('home.bannerTwo.desc')}
        </P>
        <div>
          <Button>{t('home.bannerTwo.cta')}</Button>
        </div>
      </Item>
      <Img src={maceta} alt="maceta" />
    </Main>
  )
}

export default Products

const Main = styled.main`
  width: 100vw;
  display: grid;
  grid-template-columns: 1fr 1fr;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

const Img = styled.img`
  width: 100%;
  object-fit: cover;
  height: 450px;
`

const Item = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: #365b75;
  padding: 50px 100px;
  @media (max-width: 768px) {
    padding: 50px 20px;
  }
`

const P = styled.p`
  color: white;
  text-align: justify;
  font-family: 'Comfortaa', sans-serif;
  margin-bottom: 50px;
`
